import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getIsCallbackAvailable } from '../../selectors';
import { getOfferCustomUrl } from '../../selectors/analytics';
import { toggle as toggleCallbackPopup } from '../../store/popups/callback';
import { trackCallbackOpen } from '../../tracking/callback';
import { TCallbackOpener } from '../../types/callbackPopup';

export const useCallbackButton = (placeType: TCallbackOpener): [boolean, () => void] => {
  const isCallbackAvailable = useSelector(getIsCallbackAvailable);
  const customUrl = useSelector(getOfferCustomUrl);
  const dispatch = useDispatch();

  const handleCallbackButtonClick = useCallback(() => {
    dispatch(toggleCallbackPopup(placeType, true));
    trackCallbackOpen({ label: customUrl, placeType });
  }, [customUrl, placeType, dispatch]);

  return [isCallbackAvailable, handleCallbackButtonClick];
};
